type Culture = 'en-GB' | 'en-US'

export const getCultureLanguage = (culture: Culture): string => {
  switch (culture) {
    case 'en-GB':
      return 'en'
    case 'en-US':
      return 'us'
    // v8 ignore next 2
    default:
      return 'en'
  }
}
